import type { HttpClientResponse } from '@/services/api/HttpClient';
import { HttpService } from '@/services/api/HttpService';
import type { LokiLogMessage } from '@/services/logger/transports/LokiLogTransport';

export class LoggingHttpService extends HttpService {
  log(messages: LokiLogMessage[]): HttpClientResponse<void> {
    return this.httpClient.post('log', {
      data: messages,
    });
  }
}
